export const StoreCodes = {
  CUSTOM_CONFIRMATION_NUMBERS: ['FAMILYMART', 'LAWSON', 'MINISTOP'],
  SEJ: 'SEJ',
  SEICOMART: 'SEICOMART',
};
